import script from "./ClaimsStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimsStrip.vue?vue&type=script&setup=true&lang=js"

import "./ClaimsStrip.vue?vue&type=style&index=0&id=4eb41143&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eb41143"]])

export default __exports__